<template>
<div>
    <v-tabs v-model="tab" vertical>
        <v-tab key="General">{{ $t("general") }}</v-tab>
        <v-tab key="Stage Items Prod" v-if="!value.subStage">{{
        $t("entities.stage.tabs.form.stageItemsProd")
      }}</v-tab>
        <v-tab key="Stage Items Cons" v-if="!value.subStage">{{
        $t("entities.stage.tabs.form.stageItemsCons")
      }}</v-tab>
        <v-tabs-items v-model="tab">
            <v-tab-item key="General">
                <v-container>
                    <v-form v-model="valid" ref="form">
                        <v-checkbox v-model="value.subStage" :label="$t('entities.stage.props.subStage')"></v-checkbox>
                        <v-text-field v-model="value.description" :label="$t('entities.stage.props.description')" clearable :rules="$isRequiredRule"></v-text-field>
                        <v-text-field v-model="value.seq" :label="$t('entities.stage.props.seq')" clearable :rules="$isRequiredRule"></v-text-field>
                        <auto-complete-entity v-if="value.subStage" :loading="loadingItem" ref="item" v-model="value.itemId" entityApi="item" :itemPreSelected="selectedItem" itemText="description" itemValue="id" :label="$t('entities.stage.props.itemId')" :rules="value.subStage ? $isRequiredRule : []" prependIcon="mdi-find-replace" />
                        <v-select v-if="value.subStage" :items="versions" v-model="value.versionId" item-text="description" item-value="id" :label="$t('entities.stage.props.versionId')" :rules="value.subStage ? $isRequiredRule : []" :loading="loadingVersion" />
                        <auto-complete-entity v-if="!value.subStage" ref="resource" v-model="value.resourceId" entityApi="resource" :itemPreSelected="selectedResource" fieldApi="description" itemText="description" itemValue="id" :label="$t('entities.stage.props.resourceId')" :rules="$isRequiredRule" prependIcon="mdi-find-replace" />
                        <auto-complete-entity v-if="!value.subStage" ref="stageType" v-model="value.stageTypeId" entityApi="stagetype" :itemPreSelected="selectedStageType" fieldApi="description" itemText="description" itemValue="id" :label="$t('entities.stage.props.stageTypeId')" :rules="$isRequiredRule" prependIcon="mdi-find-replace" />
                    </v-form>
                </v-container>
            </v-tab-item>

            <v-tab-item key="Stage Items Prod" eager>
                <stageItemProdsTab v-model="value" />
            </v-tab-item>
            <v-tab-item key="Stage Items Cons" eager>
                <stageItemConsTab v-model="value" />
            </v-tab-item>
        </v-tabs-items>
    </v-tabs>
</div>
</template>

<script>
import stageItemProdsTab from "./stageItemProdsTab";
import stageItemConsTab from "./stageItemConsTab";
import versionService from "@/services/versionService"
import itemService from "@/services/itemService"
export default {
    components: {
        stageItemProdsTab,
        stageItemConsTab
    },
    props: {
        value: {
            default () {
                return {
                    description: "",
                    seq: "",
                    timeSetupEstimatedMin: "",
                    timeProdEstimatedMin: "",
                    percLoss: "",
                    resourceId: "",
                    stageTypeId: "",
                    stageItemsCons: [],
                    StageItemsProd: []
                };
            }
        },
        resources: {
            default () {
                return [];
            }
        },
        stageTypes: {
            default () {
                return [];
            }
        }
    },
    data() {
        return {
            valid: true,
            tab: null,
            selectedStageType: null,
            selectedResource: null,
            selectedItem: null,
            versions: [],
            loadingVersion: false,
            loadingItem: false

        };
    },

    watch: {
        async 'value.itemId'() {
            await this.getVersions();
        },
        async value() {
            this.selectedResource = null;
            this.selectedStageType = null;
            this.selectedItem = null;
            await this.getInitial();

            return this.$refs.form.resetValidation();
        }
    },
    methods: {

        async getItem() {
            if (!this.value.itemId) return;
            this.loadingItem = true;
            let res = await itemService.getById(this.value.itemId);
            this.loadingItem = false;
            if (res.success)
                this.selectedItem = res.data
        },
        async getVersions() {
            if (!this.value.itemId) return;
            this.loadingVersion = true;
            let res = await versionService.getAll(this.value.itemId);
            this.loadingVersion = false;
            if (res.success)
                this.versions = res.data.data
        },
        isValid() {
            let resourceIsValid = true;
            let stageTypeIsValid = true;
            let itemIsValid = true;

            if (!this.value.subStage) {
                resourceIsValid = this.$refs.resource.isValid();
                stageTypeIsValid = this.$refs.stageType.isValid();
            } else {
                itemIsValid = this.$refs.item.isValid();
            }

            return resourceIsValid && stageTypeIsValid && itemIsValid && this.$refs.form.validate();
        },
        async getInitial() {
            await this.getItem();
            await this.getVersions();
            await this.getResource();
            await this.getStageType();
        },
        async getResource() {
            if (!this.value.resourceId) return;
            let res = await this.$http.get(
                `resource/s-id?id=${this.value.resourceId}`
            );
            if (res.success) this.selectedResource = res.data;
        },
        async getStageType() {
            if (!this.value.resourceId) return;
            let res = await this.$http.get(
                `stageType/s-id?id=${this.value.stageTypeId}`
            );
            if (res.success) this.selectedStageType = res.data;
        }
    },
    async mounted() {
        await this.getInitial();
    }
};
</script>
